import IconDelete from "../../../Common/Icons/IconDelete";

interface IAudioPlayer {
  file: File;
  handleFileChange?: any;
}

export default function AudioPlayerFull(props: IAudioPlayer) {
  return (
    <div className="w-full flex justify-start items-center pr-3">
      {props.file && props.file.type.match("audio.*") && (
        <audio preload="auto" controls className="bg-transparent w-96">
          <source src={URL.createObjectURL(props.file)} type="audio/ogg" />
          <source src={URL.createObjectURL(props.file)} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      )}
      {props.handleFileChange && (
        <button
          className="p-2 rounded-lg hover:bg-brij-Grey"
          onClick={() => {
            props.handleFileChange(null);
          }}
        >
          <div className="h-5 w-5 stroke-brij-Black">
            <IconDelete />
          </div>
        </button>
      )}
    </div>
  );
}
